import React, { PropTypes } from 'react'
import cx from 'classnames'

export const ModalForm = ({ onSubmit, children, customClassName }) => (
  <form onSubmit={onSubmit} className={`modal-form ${customClassName}`}>
    {children}
  </form>
)

ModalForm.propTypes = {
  onSubmit: PropTypes.func,
  customClassName: PropTypes.string
}

export const ModalFormRow = ({smallMargin, children}) => (
  <section className={cx('modal-form-row', { 'small-margin': smallMargin })}>
    {children}
  </section>
)

export const ModalFormBlock = ({size, submitButton, customClassName, children}) => {
  let styles = {
    WebkitFlexGrow: size,
    flexGrow: size
  }

  if (submitButton === true) {
    styles = {
      ...styles,
      justifyContent: 'flex-end',
      WebkitJustifyContent: 'flex-end'
    }
  }

  let customClass = customClassName || ''

  return (
    <div style={styles} className={`modal-form-block ${(submitButton) ? 'submit-button' : ''} ${customClass}`}>
      {children}
    </div>
  )
}

ModalFormBlock.propTypes = {
  size: PropTypes.number,
  submitButton: PropTypes.bool,
  customClassName: PropTypes.string
}

ModalFormBlock.defaultProps = {
  size: 1,
  submitButton: false
}

export const CheckboxGroup = ({title, children}) => (
  <div className='checkbox-group'>
    {!!title && <span className='checkbox-group-title'>{title}</span>}
    <div className='checkboxes-container'>
      {children}
    </div>
  </div>
)

CheckboxGroup.propTypes = {
  title: PropTypes.node
}

export const InlineCheckbox = ({children}) => (
  <div className='inline-checkbox'>
    {children}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/modal-form/modal-form.js